import moment from "moment";
// import "moment/locale/zh-cn";
// import "moment/dist/locale/zh-cn";
moment.locale("zh-cn");

function fromNow(dateString) {
  const targetDate = moment(dateString);
  const now = moment();

  // 检查是否在同一天
  if (now.isSame(targetDate, "day")) {
    // 获取目标时间的小时和分钟
    const hours = targetDate.hours();
    const minutes = targetDate.minutes();

    // 根据小时判断时间段
    let period = "";
    if (hours >= 0 && hours < 6) {
      period = "凌晨";
    } else if (hours >= 6 && hours < 12) {
      period = "早上";
    } else if (hours >= 12 && hours < 18) {
      period = "下午";
    } else {
      period = "晚上";
    }

    // 将24小时制转换为12小时制
    const hour12 = hours % 12 || 12; // 如果小时是0，则转换为12

    // 格式化时间为 HH:mm
    const time = `${hour12}:${minutes.toString().padStart(2, "0")}`;

    return `${period}${time}`;
  }

  // 检查是否在同一年
  if (now.isSame(targetDate, "year")) {
    // 格式化为 M月D日
    return targetDate.format("M月D日");
  }

  // 不在同一年
  return targetDate.format("YYYY年M月D日");
}

export { fromNow };
